import i18n from '../i18n';

/**
 * Estrae un messaggio leggibile da un errore API senza MAI restituire un oggetto.
 * FastAPI/pydantic ritorna `detail` come stringa (es. HTTPException) oppure come
 * LISTA di oggetti `{type, loc, msg, input}` sui 422 di validazione: renderizzare
 * quest'ultima direttamente in JSX causa React error #31. Qui i `msg` vengono
 * composti in un'unica stringa.
 *
 * Il prefisso «Value error, » è un artefatto di Pydantic v2 (wrapping dei
 * ValueError dei validator): mai utile all'utente, viene tolto. La landing fa
 * lo stesso in `messaggio422()` — tenere le due allineate.
 *
 * Il `detail` si legge PER FORMA, non dopo un `axios.isAxiosError(err)`. Quel
 * check pretendeva il marcatore `isAxiosError: true` e faceva scartare in
 * silenzio un detail perfettamente valido: e' successo su tre punti diversi
 * (riattivazione CER, CER in uso), dove il messaggio localizzato non e' mai
 * arrivato a video e l'utente ha letto il generico di fallback. Qui non
 * serviva nulla di axios — solo `response.data.detail` — e chiederlo era un
 * requisito di provenienza, non di contenuto.
 */
const PREFISSO_PYDANTIC = /^Value error, /;

export function apiErrorMessage(err: unknown, fallback?: string): string {
  fallback = fallback ?? i18n.t('common.errori.generico');
  const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) return detail;

  // `detail` OGGETTO con `message`: e' la forma dei 409 strutturati del backend
  // (`tipologia_in_uso`, `big_bag_uscito`, `tipologie_mancanti`, ...), che
  // portano un `code` per chi vuole ramificare E un `message` gia' scritto per
  // chi no. Senza questo ramo cadevano tutti nel fallback generico: il
  // messaggio curato esisteva e non arrivava mai a video.
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    const msg = (detail as { message?: unknown }).message;
    if (typeof msg === 'string' && msg.trim()) return msg;
  }

  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) =>
        d && typeof d === 'object' && 'msg' in d
          ? String((d as { msg: unknown }).msg).replace(PREFISSO_PYDANTIC, '')
          : typeof d === 'string'
            ? d
            : null,
      )
      .filter((m): m is string => !!m && m.trim().length > 0);
    if (msgs.length) return msgs.join('; ');
  }

  return fallback;
}
